import React from 'react'
import styles from './index.module.scss'
import Logo from '../../assets/img/logo.png'

const Index = () => {
    return (
        <div className={styles.navbar}>
            <img src={Logo} className={styles.logo} alt='Логотип'/>
            <a href='/'>
                <div className={styles.info}>
                    <span className={styles.infoTitle}>Бизнес-ланч</span>
                    <span className={styles.time}>12:00 - 15:00</span>
            </div>
            </a>
        </div>
    )
}

export default Index